// extracted by mini-css-extract-plugin
export default {"content":"CI","wrapper":"EI","gif":"FI","textContent":"GI","gifContainer":"HI","proteinGif":"II","counter_img":"JI","usage-container":"KI","usage-list":"LI","checklist":"MI","counter_title":"NI","counter_wrapper":"OI","active":"PI","usage-counter":"QI","line":"RI"};
    if(module.hot) {
      // 1714422956436
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  